import React from 'react';
import BlockUI from 'react-block-ui';
import LottieLoader from 'Components/LottieLoader';

const Loading = () => {
  return (
    <BlockUI
      tag="div"
      className="block-ui--relative block-ui--theme-dark block-ui--100vh"
      blocking={ true }
      loader={ <LottieLoader type="loading" loop={ true } autoplay width="75px" /> }
      renderChildren={ false }
    />
  );
};

export default Loading;
